// @flow
import { styled } from 'mz-ui-kit'

// Constants
const SIZES = {
  normal: '18px',
  inherit: 'inherit',
}

// Container for the input
export const Container = styled('label', {})

// Question button
export const HelpButton = styled<{
  $color?: string,
  $size?: $Keys<typeof SIZES>,
}>('span', ({ $color, $size, $palette }) => ({
  color: `${$palette($color).darken(15)}`,
  fontSize: $size ? SIZES[$size] : 'inherit',
}))
